let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j06N4"), load("lwfE5")]).then(() => parcelRequire('MkVVm'));